import React from 'react';
import { MoonStars } from "@phosphor-icons/react";

const IconNight = (props) => (
    <MoonStars {...props}/>
);

export default IconNight;